export function getRegisterUrl() {
	if (window.location.hostname === "test-firmenradl.intersport.at") {
		return "https://test-firmenradl.intersport.at/Account/Login?returnUrl=/db/1/app/7";
	}

	return "https://firmenradl.at/Account/Login?returnUrl=/db/1/app/9";
}
